module.exports = __webpack_public_path__ + "static/media/coast8-mobile.64d3b689.jpg";